/**
 * LawnStarter Tracking System
 * 
 * This module provides a centralized tracking function that can be used
 * throughout the application to send events to analytics services.
 */

/**
 * Track an event with LawnStarter's tracking system
 * 
 * @param {Object} event - The event object to track
 * @param {string} event.name - The name of the event (required)
 * @param {Object} event.data - Additional data to send with the event (optional)
 * @param {string} event.target - The target element or identifier (optional)
 * @param {string} event.view - The view/page context (optional, defaults to current page)
 */
function _lsTS(event) {
    // Default configuration
    var appName = 'www';
    var defaultView = window.location.pathname || 'unknown';
    
    // Validate required parameters
    if (!event || !event.name) {
        console.warn('_lsTS: Event name is required');
        return;
    }
    
    // Prepare tracking data
    var data = event.data || {};
    data.appName = appName;
    data.view = event.view || defaultView;
    
    // Add target if provided
    if (event.target) {
        data.target = event.target;
    }
    
    var trackEvent = event.name;
    
    // Send to analytics if available
    if (window.analytics && typeof window.analytics.track === 'function') {
        window.analytics.track(trackEvent, data);
    } 
    console.log('_lsTS tracking:', trackEvent, data);
}

// Attach to window object for global access
window._lsTS = _lsTS;

// Export for module systems
export { _lsTS };
